import Cookies from 'js-cookie';
import { firstOf } from '@2l/utils';
import { param } from '../../links/util'

export const twclid = firstOf(
  () => Cookies.get('_twclid'),
  () => localStorage.getItem('_ewa._twclid'),
  () => param('twclid')
);
